import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http,
    MAP_LIST
} from '$http';
// 新增 编辑
export default {
    mixins: [services],
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            form: this.getData(),
            classList: [],

        }
    },
    methods: {
        getData() {
            return cloneDeep({
                Id: 0,
                beforeClassId: 0,
                afterClassId: 0
            })
        },
        show(opts) {

            this.form = this.getData()
            this.AddDialogVisible = true
            this.title = opts.title
            this.GetClassList(opts.Id) //获取班级列表
            this.form.Id = opts.Id
            this.form.beforeClassId = opts.ClassId
        },
        handleCurrentChange(val) {
            if (val !== null) {
                this.form.afterClassId = val.ClassId
            }

        },
        // 提交
        submit() {
            if (this.form.afterClassId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请选择需要更换的检测班级！',
                    type: 'warning'
                });
                return;
            }
            this.ChangeClass()

        },
        //取消
        close() {
            this.AddDialogVisible = false
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/classListDialog/vm.js